import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-button',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './button.component.html',
  styleUrls: ['./button.component.css'],
  host: {
    class: 'button-host',
    '[class.button-host--full-width]': 'fullWidth',
  },
})

export class ButtonComponent {
  @Input() public variant: 'primary' | 'outlined' | 'squared' = 'primary';
  @Input() public buttonType: 'button' | 'submit' | 'reset' = 'button';
  @Input() public fullWidth = false;

  public get buttonClasses(): string {
    let classes = 'btn ';

    if (this.variant === 'primary') {
      classes += 'btn-fill ';
    }
    if (this.variant === 'outlined') {
      classes += 'btn-outline ';
    }
    if (this.variant === 'squared') {
      classes += 'btn-accent ';
    }

    if (this.fullWidth) {
      classes += 'btn-block ';
    }

    return classes.trim();
  }
}
